import React, { ReactNode } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Button, Col, Drawer, DrawerProps, Row } from 'components';
import './styles.scss';

interface iFilterDrawer extends DrawerProps {
  title?: string;
  footer?: ReactNode;
  children?: ReactNode;
  clearBtnText?: string;
  applyBtnText?: string;
  onClear?: () => void;
  onApply?: () => void;
  onExpand: () => void;
}

export const FilterDrawer = React.memo((props: iFilterDrawer) => {
  const { title, footer, onExpand, children, clearBtnText, applyBtnText, onClear, onApply, ...rest } = props;
  return (
    <Drawer
      closeIcon={null}
      styles={{
        header: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        },
      }}
      title={title}
      footer={footer}
      {...rest}
    >
      <div style={{ position: 'absolute', right: 16, top: 16 }}>
        <Button icon={<CloseOutlined />} onClick={onExpand} type="text" />
      </div>
      {children}
      <Row gutter={8} className={'drawer-actions'}>
        <Col span={12}>
          <Button block onClick={onClear} size={'large'}>
            {clearBtnText || 'Clear'}
          </Button>
        </Col>
        <Col span={12}>
          <Button block type={'primary'} size={'large'} htmlType={'submit'} onClick={onApply}>
            {applyBtnText || 'Apply'}
          </Button>
        </Col>
      </Row>
    </Drawer>
  );
});
